var COLORS = {
  "default": {
    id: 'default',
    bgColor: '#f5f5f7',
    textColor: '#72727D'
  },
  blue: {
    id: 'blue',
    bgColor: '#D4F4F7',
    textColor: '#30767E'
  },
  green: {
    id: 'green',
    bgColor: '#CFFCD6',
    textColor: '#38794E'
  },
  yellow: {
    id: 'yellow',
    bgColor: '#FFF3C2',
    textColor: '#974E00'
  },
  orange: {
    id: 'orange',
    bgColor: '#FFE6CC',
    textColor: '#974E00'
  },
  red: {
    id: 'red',
    bgColor: '#FFE6E6',
    textColor: '#BA1B1B'
  },
  mauve: {
    id: 'mauve',
    bgColor: '#FEE6F2',
    textColor: '#B52068'
  },
  purple: {
    id: 'purple',
    bgColor: '#F0E9FC',
    textColor: '#6B34DF'
  },
  bleu: {
    id: 'bleu',
    bgColor: '#EDF1FF',
    textColor: '#3E57E5'
  }
};
export function getAllColors() {
  return COLORS;
}
export function getColorClassName(_ref) {
  var bgColor = _ref.bgColor;
  var filteredOptions = Object.keys(COLORS).filter(function (key) {
    return COLORS[key].bgColor === bgColor;
  });
  return "slite-editor-database-tag-".concat(filteredOptions[0] || 'default');
}